import Rest from '@/services/Rest';

/**
 * @typedef {ContaAzulService}
 */
export default class ContaAzulService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/contaazul'
}
